class UsecaseNavWidget {
	constructor() {
		window.QelpCareNavigator = this;
		window._ga_laststep = 0;
		this.current = 0;
		this.init();

	}
	init() {
		const root = document.documentElement;

		// Get the computed style of the element
		const style = getComputedStyle(root);

		// Retrieve the value of the CSS variable
		this.mobile_break = Number(style.getPropertyValue('--screen-size-lg').trim().split("px")[0]);


		try {
			this.steps = document.querySelectorAll(".usecase-step");
			this.tutorial = document.querySelector(".usecase-tutorial");
			this.buttons = document.querySelectorAll(".step-progress .mdn-Swiper-pagination-custom > div");
			this.progress = document.querySelector(".progress-bar");
			this.progress_steps = this.progress.querySelectorAll(".progress-step");

			this.progress_steps.forEach(item => {
				item.addEventListener("click", e=> {
					this.gotoStep(e.currentTarget.dataset.step);
				})
			})

			this.buttons.forEach(item => {
				item.addEventListener("click", e => {
					const button = e.currentTarget;
					if (button.classList.contains("mdn-Swiper-button-next")) {
						if (this.current < this.steps.length - 1) {
							this.current ++;
						}
					} else {
						if (this.current > 0) {
							this.current --;
						}
					}

					this.gotoStep(this.current);
				})
			})
			this.initObservers();

		} catch (error) {
			console.log(error);
		}
	}
	initObservers() {
		const observerOptions = {
			root: null,
			threshold: 1
		};
		const observer = new IntersectionObserver(entries => {
			const visibleSteps = entries.filter(entry => entry.isIntersecting);

			if (visibleSteps.length > 0 && window.innerWidth <= this.mobile_break) {
				// Find the step closest to the viewport center
				const centerY = window.innerHeight / 2;

				const closestStep = visibleSteps.reduce((closest, entry) => {
					const stepTop = entry.target.getBoundingClientRect().top;
					const closestTop = closest.target.getBoundingClientRect().top;

					// Compare distances from the top (0 position)
					return Math.abs(stepTop) < Math.abs(closestTop) ? entry : closest;
				});

				this.steps.forEach(item => {
					item.classList.remove("focus");
				});
				closestStep.target.classList.add("focus")
			} 
		}, observerOptions);
		this.steps.forEach(step => observer.observe(step)); 
	}

	gotoStep(number = null) {
		if (number!=null) {
			if (0 <= number <= (this.steps.length - 1)) {
				this.current = number
			}
		}
		this.steps.forEach(item => {
			item.classList.remove("focus")
			if (item.dataset.step == this.current) {
				this.scrollItemIntoView(item);
			}
		})
		this.updateProgress();
	}
	scrollItemIntoView(item) {
		const elementTop = this.tutorial.getBoundingClientRect().top + window.scrollY;
		const offsetTop = elementTop - 80;
		window.scrollTo({ top: offsetTop, behavior: 'smooth' });


		item.classList.add("focus");
		const rect = item.getBoundingClientRect();
		var leftPosition = (rect.width * this.current);
		if (leftPosition<0)	leftPosition = 0;

		this.tutorial.scrollTo({
			"left": leftPosition,
			"behavior": "smooth"
		});
	}
	updateProgress() {
		this.steps.forEach((item, key) => {
			const progress_step = this.progress.querySelector(`.progress-step[data-step="${key}"]`)
			progress_step.classList.remove("read", "unread", "active");
			if (this.current>key) {
				progress_step.classList.add("read");
			}
			if (this.current==key) {
				progress_step.classList.add("active");
			}
			if (this.current<key) {
				progress_step.classList.add("unread");
			}
			
		})
	}
	updateViewPort() {
	}
	updateGTM(num) {
		num++;
		if (num > window._ga_laststep) {
			window._ga_laststep = num;
			try {
				dataLayer.push({
					"lastStepViewed": num,
					"completionRate": num / this.steps.length,
					// "numberOfSteps": this.steps.length
				});
			} catch (e) {
				console.log(e);
			}

		}
	}
}
window.addEventListener("eHelpFrameworkReady", e => {
	eHelpFramework.widgets.push(new UsecaseNavWidget())
});
